import React from "react";
import { format } from "date-fns";

export interface VacationDaysListEntry {
  startDate: string;
  vacationDays: number;
}

export interface VacationHistoryProps {
  vacationEntries: VacationDaysListEntry[];
}

const VacationHistory: React.FC<VacationHistoryProps> = ({
  vacationEntries,
}) => {
  if (!vacationEntries || vacationEntries.length === 0) {
    return (
      <>
        <div className="section-header">
          <h2>Urlaubstage-Verlauf</h2>
        </div>
        <p>Keine Urlaubsverlaufsdaten verfügbar.</p>
      </>
    );
  }

  // Sort entries by date (newest first)
  const sortedEntries = [...vacationEntries].sort(
    (a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime(),
  );

  const renderVacationDays = (value: number) => (
    <td>{value.toFixed(1)} Tage</td>
  );

  return (
    <>
      <div className="section-header">
        <h2>Urlaubstage-Verlauf</h2>
      </div>
      <div className="table-wrapper">
        <table className="history-table vacation-table">
          <thead>
            <tr>
              <th>Gültig ab</th>
              <th>Urlaubstage</th>
            </tr>
          </thead>
          <tbody>
            {sortedEntries.map((entry, index) => {
              try {
                return (
                  <tr key={index}>
                    <td>{format(new Date(entry.startDate), "dd.MM.yyyy")}</td>
                    {renderVacationDays(entry.vacationDays)}
                  </tr>
                );
              } catch (error) {
                console.error(`Error rendering vacation entry at index ${index}:`, entry, error);
                return null; // Skip problematic entries
              }
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default VacationHistory;